import React from "react";
import { useNavigate } from "react-router-dom";
import styles from './FeaturedIn.module.css';
import authorityMagazineImg from "../../assets/Authority-Magazine.webp";
import medicalNewsTodayImg from "../../assets/MedicalNewsToday.png";
import dailyMailImg from '../../assets/daily-mail.png';
import { trackPostHogEvent } from '../../utils/posthogUtils';

export default function FeaturedIn({ safeSource }) {
    const navigate = useNavigate();

    function handleArticles() {

        // Track articles event
        trackPostHogEvent('landing_page_submitted', {
            selected: 'see_all_features',
            to_path: '/articles'
        });

        navigate('/articles/');
    }
    function handleArticlesHover(e) {
        e.target.classList.add('animate__animated', 'animate__pulse', styles.glowGreen);
    }
    function handleArticlesHoverEnd(e) {
        e.target.classList.remove('animate__animated', 'animate__pulse', styles.glowGreen);
    }

    /* const authorityMagazineImg = window.innerWidth < 400 ? AuthorityMagazine350 : AuthorityMagazine;
    const medicalNewsTodayImg = window.innerWidth < 400 ? MedicalNewsToday350 : MedicalNewsToday;
    const dailyMailImg = window.innerWidth < 400 ? DailyMail350 : DailyMail; */

    return(
        <div className={styles.featuredInSection}>
            <h4 className={styles.featuredInTitle}>Featured In:</h4>
            <div className={styles.teamBrands}>
                <img className={styles.brandImg} src={dailyMailImg} alt='Daily Mail' onClick={safeSource ? () => {} : () => {window.open('https://www.dailymail.co.uk/health/article-13276757/deaths-linked-ozempic-weight-loss-drugs-analysis.html')}} />
                <img className={styles.brandImg} src={authorityMagazineImg} alt='Authority Magazine' onClick={safeSource ? () => {} : () => {window.open('https://medium.com/authority-magazine/paul-moss-and-antoni-adamrovich-of-tb2-health-49f6d473922c')}} />
                <img className={styles.brandImg} src={medicalNewsTodayImg} alt='Medical News Today' onClick={safeSource ? () => {} : () => {window.open('https://www.medicalnewstoday.com/articles/how-semaglutide-drugs-such-as-ozempic-can-help-with-long-term-weight-loss-and-heart-health')}}/>
            </div>
            <p className={styles.journeyButton} onMouseEnter={handleArticlesHover} onMouseLeave={handleArticlesHoverEnd} onClick={handleArticles}>See All Features</p>
        </div>
    )
}